<ng-container *ngIf="subscription">
  <button class="button is-outlined" (click)="unsubscribe()">Unsubscribe</button>
</ng-container>
